<script lang="ts">
  import { onNavigate } from '$app/navigation';
  import viewport from '$lib/actions/useViewPort';
  import { ZappsKeys } from '$lib/constants/zapps-mapping';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames } from '$lib/types/analytics';
  import { instrumentationSectionNameHandling } from '$lib/utils/analytics';

  export let sectionName: string;
  export let position = 0;
  export let eventName: EventNames = EventNames.VIEW_CARD;
  export let cta = '';
  // TODO: This is a hack to prevent the event from firing multiple times
  // improve this logic
  let hasEntered = false;

  const onEnter = async () => {
    if (!hasEntered) {
      hasEntered = true;
      // using this condition to remove the overlapping analytics events for the home news feed
      if (sectionName !== ZappsKeys.HOME_NEWS_FEED) {
        const analyticsObject: { section_name: string; position?: number; cta?: string } = {
          section_name: (await instrumentationSectionNameHandling(sectionName))!
        };
        if (position) analyticsObject.position = position;
        if (cta) analyticsObject.cta = cta;

        sendAnalyticsEvent(eventName, analyticsObject);
      }
    }
  };

  onNavigate(() => {
    hasEntered = false;
  });
</script>

<div use:viewport on:enterViewport={onEnter}>
  <slot />
</div>

<style lang="scss">
  div {
    flex: var(--flex, 1);
  }
</style>
